/**
 * 常量集合 提供给actions和reduces使用
 * @type {string}
 */

export const set_theme = 'set_theme';


